import { Injectable } from '@angular/core';
import { SQLiteDBConnection } from '@capacitor-community/sqlite';
import { ModulesManagerService } from '../classes/Module/modules-manager.service';
import { SqliRequest } from '../classes/SqliRequest/sqli-request';
import { SQLiteService } from '../services/sqlite.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})



export class SqliService {
  private manager: ModulesManagerService;
  private dbname = "data";
  private opened = false
  private db: SQLiteDBConnection = null;
  constructor(private sqlite: SQLiteService) { }

  async initiate(moduleManager: ModulesManagerService) {
    this.manager = moduleManager;

    this.manager.OfflineService.GenerateLocalDatabase()
  }

  async getConnector() {

    if (this.sqlite.platform == "web" && !this.opened) {
      await this.sqlite.initWebStore()
    }

    if (this.db != null) {
      await this.waitForReady()
      return this.db
    }


    await this.manager.Tool.DeviceReady()
    this.db = await this.sqlite.createConnection(this.DBname, false, 'no-encryption', 2, false)
    await this.db.open()
    return this.db
  }

  private async waitForReady() {
    while (!(await this.db.isDBOpen()).result) await new Promise((resolve) => setTimeout(resolve, 250))
  }

  get DBname() {
    // return this.manager?.Usr.isLoged? this.manager.Usr.EmailUser : this.dbname
    return this.dbname
  }

  async closeDb() {
    if (this.db?.close != null) await this.db.close()
    this.db = null
  }


  async executeSql(preparedQuery: string, params?: any[]): Promise<any> {

    await this.getConnector()
    let res: any = await this.db.query(preparedQuery, params).catch((error) => LoggerService.error('Erreur lors de l\'exécution de la requête SQL', error))
    const d = new Date();
    if (this.sqlite.platform == "web")
      await this.sqlite.saveToStore(this.dbname)
    if (res)
      return res.values
    else
      return null

  }

  async executeMultiSql(requests: Array<SqliRequest>): Promise<any> {
    await this.getConnector()
    for (const request of requests)
      await request.execute(this.db).catch((err) => { LoggerService.error('Erreur lors de l\'exécution d\'une requête SQL multiple', err) })
    const d = new Date();
    if (this.sqlite.platform == "web")
      await this.sqlite.saveToStore(this.dbname)
    //await this.sqlite.saveToStore(this.dbname)


  }

  getInsertedId(res: any): number {
    return res.insertId
  }
}
